import axios from 'axios'
import { uomUrl, uomTypeUrl, uomCategoryUrl, productUrl, getHeader } from './../config'

const state = {
  uomList: [],
  uomTypeList: [],
  uomCategoryList: [],
  productUomList: []
}

const mutations = {
  SET_UOM_CATEGORY_LIST (state, obj) {
    state.uomCategoryList = obj
  },
  SET_UOM_TYPE_LIST (state, obj) {
    state.uomTypeList = obj
  },
  SET_UOM_LIST (state, obj) {
    state.uomList = obj
  },
  SET_PRODUCT_UOM_LIST (state, obj) {
    state.productUomList = obj
  }
}

const actions = {
  getUomCategoryList: ({ commit }) => {
    axios.get(uomCategoryUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_UOM_CATEGORY_LIST', response.data.data)
      })
  },
  getUomTypeList: ({ commit }) => {
    axios.get(uomTypeUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_UOM_TYPE_LIST', response.data.data)
      })
  },
  getUomList: ({ commit }) => {
    axios.get(uomUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_UOM_LIST', response.data.data)
      })
  },
  getProductUomList: ({ commit }) => {
    axios.get(productUrl + '/uom', { headers: getHeader() })
      .then(response => {
        commit('SET_PRODUCT_UOM_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
